import { useAppSelector } from '@shared/store';
import { selectIsAuthorized } from '@entities/account';

export const useAccountIsAuthorized = () => {
  const isAuthorized = useAppSelector(selectIsAuthorized);

  return isAuthorized;
};
